import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlliRoutingModule } from './controlli-routing.module';
import { ControlliService } from './controlli.service';
import { IPrelievo } from './models/prelievo.model';
import { PRELIEVO_ENDPOINT,PRELIEVO_EX_ENDPOINT, PARAMETRI_OBBLIGATORI_ENDPOINT, PARAMETRI_ALERT_ENDPOINT, prelievoStateConfig, PRELIEVO_CONTROLLO_SINGOLO_ENDPOINT, dettaglioStateConfig } from './prelievo.config';
import { provideQueryService } from 'src/app/core/services/query.service';
import { TrasmissioneReportNetModule } from '../trasmissione-reportnet/trasmissione-reportnet.module';
import { ControlloSingoloService } from './controllo-singolo.service';
import { IControlliDettaglio } from './models/prelievo-dettaglio.model';
import { PrelievoService } from './prelievo.service';
import { ControlloSingoloUpdateService } from './controllo-singolo-update.service';

@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<IPrelievo>(PRELIEVO_ENDPOINT, prelievoStateConfig),
    ...provideQueryService<IPrelievo>(PRELIEVO_EX_ENDPOINT, prelievoStateConfig),
    ...provideQueryService<IPrelievo>(PARAMETRI_OBBLIGATORI_ENDPOINT, prelievoStateConfig),
    ...provideQueryService<IPrelievo>(PARAMETRI_ALERT_ENDPOINT, prelievoStateConfig),
    ...provideQueryService<IControlliDettaglio>(PRELIEVO_CONTROLLO_SINGOLO_ENDPOINT, dettaglioStateConfig),
    ControlliService,
    ControlloSingoloService,
    PrelievoService,
    ControlloSingoloUpdateService,
  ],
  imports: [
    CommonModule,
    ControlliRoutingModule,
    TrasmissioneReportNetModule
  ]
})
export class ControlliModule {}
